import { useSelector } from "react-redux";
import { hasPermission as checkPermission } from "../utils/permissionUtils";

const usePermission = () => {
  const permissions = useSelector((state) => state.auth.permissions);

  const hasPermission = (module, action = "view") => {
    return checkPermission(permissions, module, action);
  };

  return { hasPermission };
};

export default usePermission;
